import { useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { Alert, Snackbar } from "@mui/material";
import { Table, TableBody, TableCard, TableCell, TableHead, TableHeaderWrap, TableRow, } from "../../../../component/table/table-layout";
import { TitleHeading } from "../../../../component/ui/layout";
import StockSupplyPopup from "../popup";
import Tooltip from "../../../../component/ui/tooltip";
import { PlusIcon } from "lucide-react";
import { FeildWraper } from "../../../../component/form/form-layout";
import moment from "moment";

const StockSupplyTrendList = () => {
  const [alertData, setAlertData] = useState({ isShow: false });
  const [isMothlyLoading, setIsMothlyLoading] = useState(true);
  const [monthlyData, setMonthlyData] = useState([]);
  const [monthlyHeader, setMonthlyHeader] = useState([])
  const [dropdowns, setDropdowns] = useState({});
  const [years, setYears] = useState([]);
  const [customYear, setCustomYear] = useState("")

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    // getMonthlyData();
    getDropdowns();
  }, []);


  useEffect(() => {
    getMonthlyData();
    // getDropdowns()
  }, [customYear]);

  useEffect(() => {
    let customYear = [];
    let currentYear = moment(new Date()).format("YYYY");
    for (let i = 2025; i <= currentYear; i++) {
      customYear.push(i);
    }
    setYears(customYear);
  }, []);

  const getMonthlyData = async () => {
    setIsMothlyLoading(true);
    try {
      let apiRes = await apiCall({ method: "get", url: `get-monthly-purchase-trends${customYear ? `?year=${customYear}`: ""}` })
      setMonthlyData(apiRes?.data);
      setMonthlyHeader(apiRes?.headers)
      setIsMothlyLoading(false)
    } catch (error) {
      console.log("Err", error)
    }
  }

  const getDropdowns = async () => {
    try {
      let apiRes = await apiCall({ method: "get", url: "get-supply-dropdown-list" })
      setDropdowns(apiRes?.data);
    } catch (error) {
      console.log("Error", error)
    }
  };

  const [addModal, setAddModal] = useState(false);
  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getMonthlyData();
    setAddModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className={Style.report_table__header}>
          <span className={Style.report_table__title}>
            <TitleHeading title={`Monthly Purchase Trend`} />
          </span>

          <div className={Style.bpfl_action}>
            <div
              className={Style.bpfl_action}
              onClick={() => { setAddModal(true) }}
            >
              <Tooltip
                content={"Add Data"}
                position={"left center"}
                className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
              >
                <div className={Style.icon}>
                  <PlusIcon size={'1em'} />
                </div>
              </Tooltip>
            </div>
            <div className="">
              <FeildWraper className={"!w-full !py-0"}>
                <select value={customYear} onChange={(e) => {setCustomYear(e.target.value)}} className="!w-[180px]">
                  <option value="">Last 12 Months</option>
                  {years?.map((eachYear, index) => (
                    <option value={eachYear} key={index}>{eachYear}</option>
                  ))}
                  {/* <option value="">2024</option>
                  <option value="">2023</option>
                  <option value="">2022</option> */}
                </select>
              </FeildWraper>
            </div>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          <TableCard>
            {(isMothlyLoading) ? (
              <InnerLoader />
            ) : !monthlyData?.length ? (
              <div className="w-full h-full flex items-center justify-center">
                <DataNotFound title={"Monthly Data"} />
              </div>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell header sticky>
                      <div className="flex gap-4 items-center">
                        <span>Month</span>
                      </div>
                    </TableCell>

                    {
                      monthlyHeader?.map((h_ele, h_idx) => 
                        (h_ele.show == 1 && h_ele?.is_visible == 1) ?
                        <TableCell header>
                          <TableHeaderWrap>
                            <span>{h_ele?.value}</span>
                          </TableHeaderWrap>
                        </TableCell>
                        :
                        null
                      )
                    }
                  </TableRow>
                </TableHead>

                <TableBody>
                  {monthlyData?.map((eachList, index) => {
                    return (
                      <TableRow key={`${index}`}>
                        <TableCell sticky>
                          <div className={`${Style.tableActionArea} !gap-4`}>
                            <div className="flex gap-[10px]">
                              <div className="flex items-center gap-3">
                                <div className="font-semibold text-[15px] leading-5">{eachList?.month}</div>
                              </div>
                            </div>
                          </div>
                        </TableCell>

                        {
                          monthlyHeader?.map((h_ele, h_idx) => 
                            (h_ele.show == 1 && h_ele?.is_visible == 1) ?
                            <TableCell key={`mon_${h_idx}_${index}`}>
                              <TableHeaderWrap>
                                <span>{eachList[h_ele?.key]}</span>
                              </TableHeaderWrap>
                            </TableCell>
                            :
                            null
                          )
                        }
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </TableCard>
        </div>
      </div>

      {addModal &&
        <StockSupplyPopup
          onClose={() => { setAddModal(false); }}
          onError={onError}
          onSubmit={onSuccess}
          dropdowns={dropdowns}
        />
      }

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default StockSupplyTrendList;
